import Routes from "./routes/Routes";
import {
  GET_ORGANISATION_FROM_TENENT_ID,
  GET_PERSON_FROM_UID,
  GET_PRACTITIONER_FROM_UID,
} from "adapters/auth.service";
import {
  CREATE_PRACTITIONER,
  GET_CUSTOMER_SUBSCRIPTION,
  GET_LOCATIONS,
  GET_PLANS_LIST,
  GET_USER_SETTINGS,
  SAVE_USER_SETTINGS,
} from "adapters/ehr.service";
import UnauthorizedAccess from "components/dialogs/UnauthorizedAccess";
// import IdleController from "components/idle/IdleController";
import FallBackLoader from "components/loader/FallbackLoader";
import { cacheTenantIds } from "config/helpers/common_helper";
// import ChatProvider from "context/chatProvider";
import dayjs from "dayjs";
import { auth } from "firebase-setup";
import { onAuthStateChanged, signOut } from "firebase/auth";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/plugins.pkgd.min.css";
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  add_user_data,
  change_app_language,
  change_login,
  full_page_loader,
  reset_state,
} from "redux/actions/AppActions";
import {
  set_current_user_configuration,
  set_current_user_setting,
  set_organistion_details,
  set_person_details,
  set_practitioner_details,
} from "redux/actions/AuthActions";
// import { reset_subscription } from "redux/actions/SubscriptionAction";
import { constants } from "redux/constants/redux-constants";
import "style_v2/global.scss";
import getCurrentAudioLanguage from "./getCurrentAudioLanguage";
import getCurrentLanguage from "./getCurrentLanguage";
import Confirmation from "components/ui/ConfirmationDialog/ConfirmationDialog";
import { set_available_plans, set_current_subscription } from "redux/actions/SubscriptionAction";
import { setPlanStatus } from "redux/actions/LicenseAction";
import { getPlanStatus } from "screens/store/storeHelper";
import { set_available_locations } from "redux/actions/LocationActions";
import { createUserConfiguration, GET_USER_CONFIGURATION } from "adapters/orie.service";

const App = () => {
  const reduxDispatch = useDispatch();
  const navigate = useNavigate();

  const [firebaseUser, setFirebaseUser] = useState(null);
  const [isFirebaseLoaded, setIsFirebaseLoaded] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);
  const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);
  const [open, setOpen] = useState(false);
  const [totalRetriesToFetchFhirPerson, setTotalRetriesToFetchFhirPerson] = useState(0);
  const [openAlertToRefresh, setOpenAlertToRefresh] = useState();

  let shouldShowTrialScreen = false;

  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
  }

  // const alertUser = (event) => {
  //   event.preventDefault();
  //   event.returnValue = "The chat will be lost. Do you want to continue?";
  //   return "The chat will be lost. Do you want to continue?";
  // };
  // const handleTabClosing = async () => {
  //   localStorage.removeItem("conversations");
  //   deleteCookie("session_id");
  // };

  // useEffect(() => {
  //   window.addEventListener("beforeunload", alertUser);
  //   window.addEventListener("unload", handleTabClosing);
  //   return () => {
  //     window.removeEventListener("beforeunload", alertUser);
  //     window.removeEventListener("unload", handleTabClosing);
  //   };
  // });

  useEffect(() => {
    setCurrentLocation(window.location?.pathname);
  }, [window.location]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        let roles = user?.reloadUserInfo?.customAttributes
          ? JSON.parse(user?.reloadUserInfo?.customAttributes)
          : { enlivRoles: [] };
        if (navigator?.onLine && roles?.enlivRoles?.includes("portal_user")) {
          setOpen(true);
          signOut(auth)
            ?.then(() => {
              let tenantsList = localStorage.getItem("tenants") || "[]";
              localStorage?.clear();
              localStorage.setItem("tenants", tenantsList);
              setFirebaseUser(null);
              setIsFirebaseLoaded(true);
            })
            .catch((e) => {
              console.log(`some issue in firebase signout`, e);
            });
          reduxDispatch(full_page_loader(false));
          return false;
        }
        setFirebaseUser(user);
        user
          ?.getIdToken()
          ?.then((token) => {
            localStorage?.setItem("jwtToken", token);
            const jwtPayLoad = jwtDecode(token);
            reduxDispatch(
              add_user_data({
                resource: jwtPayLoad,
                userId: jwtPayLoad?.user_id,
              })
            );
            reduxDispatch(change_login(constants?.USER_CHECK_LOGIN));
            setIsFirebaseLoaded(true);
          })
          .catch((error) => {
            setFirebaseUser(null);
            setIsFirebaseLoaded(true);
          });
      } else {
        setFirebaseUser(null);
        setIsFirebaseLoaded(true);
      }
    });

    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    refreshUserData(firebaseUser, isFirebaseLoaded);
  }, [firebaseUser, isFirebaseLoaded]);

  const createUserSetting = async (userId) => {
    const language = getCurrentLanguage();
    const audioLanguage = getCurrentAudioLanguage();

    const systemLanguage = navigator?.language || navigator?.userLanguage;
    const languageCode = language || systemLanguage.split("-")[0] || "en";
    const audioLanguageCode =
      audioLanguage || systemLanguage.split("-")[0] || "en";

    let setting = {
      theme: "light",
      language: languageCode || "en",
      // isIntroDone: false,
      isIntroDone: true,
      isNewUser: true,
      // isWelcomeScreenShown: false,
      isWelcomeScreenShown: true,
      audioLanguage: audioLanguageCode || "en",
      print_watermark: true,
      dashboard_selected_widgets: [
        "Start Encounter",
        "Search Patient",
        "Create Patient",
        "Clinical Notes",
      ],
      persistAgentContext: true,
      persistSessionContext: true,
    };

    let payload = {
      resourceType: "Basic",
      code: {
        coding: [
          {
            system: "http://enliv.com/code/basic-resource-type",
            code: "user.preference.ui",
          },
        ],
      },
      subject: {
        reference: `Person/${userId}`,
      },
      created: dayjs().format("YYYY-MM-DD"),
      extension: [
        {
          url: "http://enliv.com/settings/data",
          valueString: JSON.stringify(setting),
        },
      ],
    };

    const response = await SAVE_USER_SETTINGS(`POST`, payload);
    return response;
  };

  const createPractitionerFromPerson = async (personPayload, uid) => {
    personPayload.resourceType = "Practitioner";
    if (Object.hasOwn(personPayload, "extension")) {
      delete personPayload.extension;
    }

    if (Object.hasOwn(personPayload, "meta")) {
      delete personPayload.meta;
    }

    if (Object.hasOwn(personPayload, "id")) {
      delete personPayload.id;
    }

    personPayload.identifier = [
      {
        system: "http://enliv.com/user-id",
        type: {
          coding: [
            {
              code: "UID",
              system: "http://enliv.com/user-id",
              userSelected: false,
            },
          ],
        },
        use: "usual",
        value: uid,
      },
    ];

    personPayload.qualification = [
      {
        code: {
          coding: [
            {
              code: "207L00000X",
              display: "Anesthesiology",
              system: "http://nucc.org/provider-taxonomy",
            },
          ],
          text: "Anesthesiology",
        },
      },
    ];

    return await CREATE_PRACTITIONER(personPayload);
  };

  const getUserSubscription = async () => {
    const currentSubscription = await GET_CUSTOMER_SUBSCRIPTION();

    if (currentSubscription) {
      reduxDispatch(set_current_subscription(currentSubscription));
      return currentSubscription;
    }
  };

  const getPlans = async () => {
    try {
      const res = await GET_PLANS_LIST();
      reduxDispatch(set_available_plans(res?.products));
      return res?.products;
    } catch (e) {
      console.error(e);
    }
  };

  const getLoggedInPersonData = async (uid) => {
    setIsUserDataLoaded(false);
    if (totalRetriesToFetchFhirPerson >= 3) {
      setOpenAlertToRefresh(true)
      return false
    }

    // const currentSubscription = await getUserSubscription();

    // reduxDispatch(
    //   setPlanStatus(getPlanStatus(currentSubscription?.subscriptions))
    // );
    // const availablePlans = await getPlans();

    try {
      let response = await GET_PERSON_FROM_UID(uid);
      const PersonID = response?.resource?.id;
      const jwtPayload = jwtDecode(localStorage.getItem("jwtToken"));
      const tenantId = jwtPayload?.firebase?.tenant;

      const availableLocations = await GET_LOCATIONS();

      if (availableLocations?.data?.entry) {
        reduxDispatch(set_available_locations(availableLocations?.data?.entry));
      }else {
        reduxDispatch(set_available_locations([]));
      }

      if (PersonID) {
        reduxDispatch(set_person_details(response?.resource));

        const OrganisationData = await GET_ORGANISATION_FROM_TENENT_ID(
          tenantId
        );
        reduxDispatch(set_organistion_details(OrganisationData?.resource));

        let PractitionerData = await GET_PRACTITIONER_FROM_UID(uid);
        if (!PractitionerData?.resource?.id) {
          PractitionerData = await createPractitionerFromPerson(
            { ...response?.resource },
            uid
          );
        }

        reduxDispatch(
          set_practitioner_details(
            PractitionerData?.resource || PractitionerData?.data
          )
        );

        let currentUserSetting = await GET_USER_SETTINGS(PersonID);

        if (currentUserSetting?.data?.total) {
          const rawData = {
            ...currentUserSetting?.data?.entry?.[0]?.resource,
          };
          const displaySetting = rawData?.extension?.find(
            (item) => item?.url === "http://enliv.com/settings/data"
          )?.valueString;

          let savedSettings = JSON?.parse(displaySetting);

          if (
            !savedSettings?.language ||
            (savedSettings?.language !== "en" &&
              savedSettings?.language !== "es")
          ) {
            const systemLanguage =
              navigator?.language || navigator?.userLanguage || "en";
            const languageCode = systemLanguage.split("-")[0];
            savedSettings.language = languageCode || "en";
          }
          if (savedSettings?.isWelcomeScreenShown === false) {
            shouldShowTrialScreen = false;
          }

          reduxDispatch(
            set_current_user_setting({
              resource: { ...rawData },
              display: {
                ...savedSettings,
                //  theme: "light"
              },
            })
          );
        } else {
          shouldShowTrialScreen = false;
          const responseSetting = await createUserSetting(PersonID);
          reduxDispatch(
            set_current_user_setting({
              resource: { ...responseSetting?.data },
              display: JSON?.parse(
                responseSetting?.data?.extension?.[0]?.valueString
              ),
            })
          );
        }

        let currentUserConfiguration = await GET_USER_CONFIGURATION({
          organizationId: OrganisationData?.resource?.id,
        })
        if (!currentUserConfiguration?.data?.total) {
          // No existing user configuration, create one
          let responseConfig = await createUserConfiguration({
            organizationId: OrganisationData?.resource?.id,
          });
          reduxDispatch(
            set_current_user_configuration({
              resource: { ...responseConfig?.data },
              configuration: JSON?.parse(
                responseConfig?.data?.extension?.[0]?.valueString
              ),
            })
          );
        }else {
          // User configuration exists
          const rawConfigData = { ...currentUserConfiguration?.data?.entry?.[0]?.resource };
          const configDataString = rawConfigData?.extension?.find(
            (item) => item?.url === "http://enliv.com/configuration/data"
          )?.valueString;
          let savedConfig = JSON?.parse(configDataString);
          // You can dispatch this configuration to redux if needed
          reduxDispatch(
            set_current_user_configuration({
              resource: { ...rawConfigData },
              configuration: savedConfig,
            })
          );
        }

        setIsUserDataLoaded(true);
      } else {
        setTimeout(() => {
          setTotalRetriesToFetchFhirPerson((prevRetries) => prevRetries + 1);
          getLoggedInPersonData(uid)
        }, 2000);
      }
    } catch (e) {
      console.error(e);
    } finally {
      reduxDispatch(full_page_loader(false));
    }
  };

  const refreshUserData = async (firebaseUser, isFirebaseLoaded) => {
    if (isFirebaseLoaded) {
      reduxDispatch(full_page_loader(true));
      if (firebaseUser) {
        await getLoggedInPersonData(firebaseUser?.uid);

        if (currentLocation === "/login") {
          // navigate(`/home/dashboard`, { replace: true });
          navigate(process.env.REACT_APP_ENTRY_POINT_AFTER_LOGIN, { replace: true });
        }
        cacheTenantIds({
          tenantId: firebaseUser?.tenantId,
          email: firebaseUser?.email,
        });
      } else {
        // const tempLang = language;
        const language = getCurrentLanguage();
        reduxDispatch(change_login(constants?.USER_LOGOUT));
        reduxDispatch(reset_state());
        reduxDispatch(change_app_language(language || "en"));
        // navigate(`/login`, { replace: true });
        setIsUserDataLoaded(true);
      }
    }
  };


  return (
    <>
      <UnauthorizedAccess open={open} setOpen={setOpen} />
      {(isFirebaseLoaded && isUserDataLoaded && (
        <>
          {/* <ChatProvider> */}
          <Routes />
          {/* </ChatProvider> */}
        </>
      )) || <FallBackLoader />}
      {openAlertToRefresh && (
        <Confirmation
          open={openAlertToRefresh}
          setOpen={setOpenAlertToRefresh}
          title={"Opps!!!"}
          message={"We're experiencing some issues, please refresh the page."}
          callback={() => window.location.reload()}
          autoFocus={"cancel"}
          showCancel={false}
          okText="Refresh"
          cross={false}
          preventCloseFromBackground={true}
        />
      )}
    </>
  );
};

export default App;
